<template>
    <b-container class="container-lg">
        <b-row class="pb-2">
            <b-col class="text-start text-truncate">
                <h5>
                    <i class="fa-solid fa-chevron-left" @click="goBack"></i> <i
                    class="text-primary fa-solid fa-info"></i> {{ $t('Mailing list') }}
                </h5>
            </b-col>
        </b-row>
        <b-list-group v-if="ready" class="mt-3">
            <b-list-group-item>
                <div class="d-flex w-100 justify-content-between">
                    <small class="ms-2 mb-1 col-4"><b>{{ $t('Name') }}:</b></small>
                    <small class="text-end">{{ mailinglist.name }}</small>
                </div>
                <div v-if="mailinglist.description && mailinglist.description !== ''"
                     class="d-flex w-100 justify-content-between">
                    <small class="ms-2 mb-1 col-4"><b>{{ $t('description') }}:</b></small>
                    <small class="text-end">{{ mailinglist.description }}</small>
                </div>
                <div class="d-flex w-100 justify-content-between">
                    <small class="ms-2 mb-1 col-4"><b>{{ $t('Department') }}:</b></small>
                    <small class="text-end">{{ mailinglist.department }}</small>
                </div>
                <small v-if="mailinglist.mailinglist_recipients.length > 0" class="mt-2"><b>{{ $t('Recipients') }}:</b></small>
                <small v-if="mailinglist.mailinglist_recipients.length > 0">
                    <ul v-for="recipient in mailinglist.mailinglist_recipients"
                        class="d-flex w-100 justify-content-between">
                        <li>
                            {{ recipient.name }}
                        </li>
                        {{ recipient.email }}
                    </ul>
                </small>
            </b-list-group-item>
        </b-list-group>
    </b-container>

</template>

<script>
import { BListGroupItem } from 'bootstrap-vue-next';

export default {
    name: "MailinglistInfo",
    components: {BListGroupItem},
    data() {
        return {
            ready: false,
            mailinglist: {}
        }
    },

    mounted() {
        this.getData();
    },

    methods: {
        getData: function() {
            const id = this.$route.params.id;
            axios.post('/resourcegroups/mailinglist.json', null, {
                params: {
                    id: id
                }
            })
                .then(response => {
                    this.mailinglist = response.data.mailinglist.all_mailinglists[0] ?? {};
                    console.log(this.mailinglist)
                    this.ready = true;
                })
                .catch(error => {
                    console.log(error)
                });
        },
        toResources: function(resourcegroup) {
            if(resourcegroup.length === 0) {
                return;
            }
            this.$router.push({name: 'resourcesIndex', query: {resourcegroups: resourcegroup}});
        },
        goBack() {
            this.$router.go(-1);
        }
    }
}
</script>


<style scoped>
.state-button-small {
    padding: 0 2px;
    font-size: 12px;
}
</style>
